export const LINKS_CONFIG = {
  DOCUMENTATION_WIKI:
    "https://w.amazon.com/bin/view/MODE/Data_Technology/Products/TaCS/",
  BULK_UPLOAD_WIKI:
    "https://w.amazon.com/bin/view/MODE/Data_Technology/Products/TaCS/UserGuide/BulkFeatures/Campaign/",
};
